import isEqual from 'lodash.isequal';
import { useEffect, useState } from 'react';
import { onResize$ } from 'utils/onResize';

type Viewport = {
  width: number;
  height: number;
};

function useViewport(): Viewport {
  const [viewport, setViewport] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const subscription = onResize$()
      .map(() => ({ width: window.innerWidth, height: window.innerHeight }))
      .distinctUntilChanged(isEqual)
      .subscribe(setViewport);

    return () => subscription.unsubscribe();
  }, []);

  return viewport;
}

export default useViewport;
